"use client";
import { Block } from "/components/Layout";
import styles from "./Textarea.module.scss";

type TextareaProps = {
  name: string;
  label?: string;
  placeholder?: string;
  error?: any;
  disabled?: boolean;
  register?: any;
  style?: any;
  value?: string;
  defaultValue?: string;
};

const Textarea = ({
  name,
  label,
  placeholder,
  error = {},
  disabled = false,
  register,
  ...res
}: TextareaProps) => {
  return (
    <div className={styles.inputWrap}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          <span className="body-text">{label}</span>
        </label>
      )}
      <textarea
        name={name}
        id={name}
        placeholder={placeholder}
        disabled={disabled}
        ref={register}
        className={styles.textarea}
        rows={4}
        {...res}
      />

      {error?.[name] && (
        <Block top={2}>
          <div className="text-label color--red">↑ {error[name].message}</div>
        </Block>
      )}
    </div>
  );
};

export default Textarea;
